export const data = {
	name: "Rosaline Su • 苏睿思",
	occupation: "NLP Data Scientist",
	greeting: "I enjoy working with people from different backgrounds and I love to learn things from others and spark new ideas.",
	description: "I am very interested in understanding language models' behaviors and how the training stage affects models to behave in certain ways. I am currently interested in model bias and fairness, interpretting models for specific use cases, and improving models in specific text domains. My roots in computer science also steer me towards open-source engineering projects.",
	chineseDescription: "我是一个研究自然语言处理的工程师，我相信自然语言处理不光是一种技术，它也是我们突破语言心理学的一个重要枢纽。我的兴趣在于：如何应用自然语言处理这项技术来让人与人之间的沟通变得更加容易和便捷。使沟通无结界。",
	image: "small_closeup.jpeg",
	email: "mailto:rosalinesu@email.com",
	linkedin: "https://www.linkedin.com/in/rosaline-su-65b891132/",
	github: "https://github.com/ruisi-su",
}
